<template>
  <div id="pmlst-steptracker">
    <div class="pmlst-steptracker-wrapper">
      <progress :value="value" :max="max"></progress>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pure-step-tracker',
  /**
   * Data being passed should always be an object with the following
   * structure...
   *
   * {
   *   current: 0,
   *   max: 3
   * }
   *
   * ...where...
   * "current" is the number of steps that have already been completed.
   * "max" is the number of steps in the complete process.
   */
  props: {
    steptracker: {
      type: Object,
      required: true
    }
  },
  computed: {
    value() {
      return this.$props.steptracker.current
    },
    max() {
      return this.$props.steptracker.max
    }
  }
}
</script>
